<template>
  <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      append-to-body
      size="80%"
  >
    <div class="unitsTitle">
      <img src="../../assets/images/student/unitsTitle.png" alt="" width="100%">
      <div class="text">小组成绩展示</div>
    </div>
    <div class="main">
      <div class="group-list">
        <div class="group-item" v-for="(item,index) in tableData" :key="index">
          <div class="group-box">
            <div class="group-name">{{ item.xzmc }}</div>
            <div class="group-progress">排名：第<span
                style="font-size:18px;margin:0 2px;color:#F56C6C">{{ index + 1 }}</span>名<span
                style="margin-left:10px">平均<span
                style="font-size:18px;margin:0 2px;color:#67C23A">{{ item.pjchl }}</span>个</span></div>
            <div class="group-student">
              <div class="group-student-item" v-for="(itm,inx) in item.xsidAndMcRespList" :key="inx">
                <span style="font-size:14px;color:#666">{{ itm.xsxm }}</span>
                <div class="group-student-speed">
                  <el-progress :stroke-width="12" :percentage="format(maxChl,itm.yzwl)*100"
                               :format="function(){return null}" :color="customColorMethod"></el-progress>
                </div>
                <div class="img-gif">
                  <img style="width:60px;height:60px;" :src="require('../../assets/images/teacher/q1.gif')" alt=""
                       v-show="inx==0">
                  <img style="width:50px;height:50px;" :src="require('../../assets/images/teacher/q2.gif')" alt=""
                       v-show="inx==1">
                  <img style="width:50px;height:50px;" :src="require('../../assets/images/teacher/q3.gif')" alt=""
                       v-show="inx==2">
                  <img style="width:50px;height:50px;transform: scaleX(-1);" :src="require('../../assets/images/teacher/q6.gif')" alt=""
                       v-show="inx==3">
                  <img style="width:60px;height:60px;transform: scaleX(-1);" :src="require('../../assets/images/teacher/q7.gif')" alt=""
                       v-show="inx==4">
                  <img style="width:50px;height:50px;" :src="require('../../assets/images/teacher/q4.gif')" alt=""
                       v-show="inx==5">
                  <img style="width:50px;height:50px;transform: scaleX(-1);" :src="require('../../assets/images/teacher/q8.gif')" alt="" v-show="inx>5">
                </div>
                <span style="font-size:14px;color:#666;margin-left:5px">{{ itm.yzwl }}个</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {screenGroupRankingApi} from '@/api/teacher.js'

export default {

  data() {
    return {
      drawer: false,
      direction: 'rtl',
      tableData: [1],
      maxChl: 0,
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      search_data: {
        yhid: this.$store.state.userInfo.yhid,
        zhid: this.$store.state.userInfo.zhid,
        bjid: JSON.parse(sessionStorage.getItem('jxInfo')).bjid,
      },
    }
  },
  methods: {
    handleClose(done) {
      this.drawer = false
    },
    format(average, num) {
      const percentage = (Number(num) / Number(average)).toFixed(2)
      console.log(percentage)
      return percentage
    },
    customColorMethod(percentage) {
      if (percentage < 50) {
        return '#E86452';
      } else if (percentage < 60) {
        return '#E6A23C';
      } else if (percentage < 70) {
        return '#5B8FF9';
      } else if (percentage < 80) {
        return '#6f7ad3';
      } else if (percentage < 90) {
        return '#5AD8A6';
      } else if (percentage > 90) {
        return '#67C23A';
      }
    },
    // 获取小组排名
    getGroupRankingList() {
      const data = this.search_data;
      data.qryDate = new Date().toISOString().slice(0, 10);
      data.bjrs = 4;
      data.currentPage = this.pages.currentPage;
      data.pageSize = this.pages.pageSize;
      screenGroupRankingApi(data).then(res => {
        if (res.result) {
          this.pages.total = res.result.total
          this.tableData = res.result.list;
          this.maxChl = this.tableData[0].xsidAndMcRespList[0].yzwl;
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep  .el-drawer {
  background-image: url('../../assets/images/student/unitsBanner.png');
}

.unitsTitle {
  width: 50%;
  display: inline-block;
  position: absolute;
  left: 50%;
  top: 20px;
  z-index: 9999;
  transform: translateX(-50%);

  .text {
    position: absolute;
    top: 0.8vw;
    width: 100%;
    text-align: center;
    color: #000;
    font-size: 1.7vw;
  }
}

.main {
  background-image: url('../../assets/images/student/unitBg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: absolute;
  width: 98%;
  height: 86%;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
  padding: 3vw 1vw 1vw 1vw;
  margin-top: 20px;
  overflow-y: scroll;
  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 10px; /* 滚动条宽度 */
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; /* 滚动条轨道背景 */
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: gray; /* 滚动条颜色 */
    border-radius: 10px;
    border: 2px solid #f1f1f1; /* 滚动条边框 */
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: gray; /* 滚动条悬停时颜色 */
  }
}

.group-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding: 15px;
}

.group-item {
  width: 300px;
  height: 400px;
  padding: 20px;
  margin: auto;
  box-sizing: border-box;
  background: #e6b94040;
  border-radius: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.group-name {
  color: #66b1ff;
  font-size: 20px;
  font-weight: 600;
  margin: 10px 0;
}

.group-progress {
  margin: 10px 0;
}

.group-student {
  width: 100%;
}

.group-student-item {
  display: flex;
  align-items: center;

  span {
    width: 140px;
  }

  .group-student-speed {
    width: 270px;
    margin-left: 20px;
  }

  .img-gif {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .group-item:first-child {
    border-right: #66b1ff dotted 2px;
  }
}
</style>



